import React from "react";
import { Switch, Router } from "react-router-dom";

import MaintenancePage from "@/components/maintenancePage";
import { PageWithSimpleLayout } from "@/components/page/Page";
import AppRoute from "./AppRoute";
import AppRedirect from "./AppRedirect";

/**
 * Replaces the standard Revenue Management router app links with
 * an under maintenance screen.
 */
export const MaintenanceRouter = ({ history }) => (
  <Router history={history}>
    <Switch>
      <AppRoute path="/maintenance" render={PageWithSimpleLayout(MaintenancePage)} />
      <AppRedirect
        from="/*"
        to="/maintenance"
        render={PageWithSimpleLayout(MaintenancePage)}
      />
    </Switch>
  </Router>
);

export default MaintenanceRouter;
